import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  GET: 'GET_STAT',
};

export const getStat = (startDate, endDate) => ({
  type: ACTION.GET,
  payload: RestClient.request({
    method: 'get',
    url: `${Constants.API_PROJECT_INSPECTION}statistic/`,
    params: {
      start_date: startDate,
      end_date: endDate,
    },
  }).catch(err => Promise.reject(err.response.data.detail)),
});



// WEBPACK FOOTER //
// ./src/redux/stat/stat_actions.js